var _style, _defs, _defs2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirthingsSimpleLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 33",
    style: {
      enableBackground: "new 0 0 33 33"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M11.8,21.2l3.7-8.8c0.2-0.6,0.7-0.7,1-0.7c0.3,0,0.8,0.1,1,0.7l3.7,8.8H11.8z M0,16.5L0,16.5 c0,4.4,1.7,8.6,4.8,11.7c3.1,3.1,7.3,4.8,11.7,4.8s8.6-1.7,11.7-4.8c3.1-3.1,4.8-7.3,4.8-11.7s-1.7-8.6-4.8-11.7 C25.1,1.7,20.9,0,16.5,0S7.9,1.7,4.8,4.8C1.7,7.9,0,12.1,0,16.5z M26.3,26.1L20,11.4C19.4,9.8,17.9,9,16.5,9 c-1.4,0-2.9,0.8-3.5,2.3L6.7,26.1c-2.4-2.5-3.9-5.9-3.9-9.6c0-7.6,6.2-13.8,13.8-13.8s13.8,6.2,13.8,13.8 C30.3,20.3,28.7,23.7,26.3,26.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -30,
    y: -29,
    width: 1366,
    height: 1024
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -5,
    className: "st1",
    width: 43,
    height: 43
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirthingsSimpleLogo);
export default __webpack_public_path__ + "static/media/airthings_simple_logo.b185b47e703f4df3229e59ab93a62cf6.svg";
export { ForwardRef as ReactComponent };